import vrShowApi from '../../apis/vr.show.api';
import icsRecordsApi from '../../apis/ics.api';
import * as constName from '@/services/const.service';
export default {
  state: {
    salesInfo: { salesId: 0 },
    vrSalesInfo: {
      salesId: 0,
      channelId: '',
    },
    userInfo: {
      userName: '之家用户',
      userId: 0,
    },
    saleSetting: {
      saleCount: 0,
      saleId: 0,
      settingShowOrNot: false,
      acceptVisit: false,
      messageOpen: false,
    },
    userVisitCount: 0,
    onlineSaler: null,
    baseSalerInfo: null,
    icsRecordsSalerInfo: {
      salesId: 0,
      salesName: '',
      photoUrl: '',
      sex: '',
      token: '',
    },
    encrysalesid: '',
  },
  getters: {
    baseSalerInfo: (state) => state.baseSalerInfo,
    salesInfo: (state) => state.salesInfo,
    vrSalesInfo: (state) => state.vrSalesInfo,
    userInfo: (state) => state.userInfo,
    saleSetting: (state) => state.saleSetting,
    hasOnlineSaler: (state) => !!state.onlineSaler,
    onlineSaler: (state) => state.onlineSaler,
    userVisitCount: (state) => state.userVisitCount,
    icsRecordsSalerInfo: (state) => state.icsRecordsSalerInfo,
    encrysalesid: (state) => state.encrysalesid,
  },
  mutations: {
    setEncrysalesId(state, encrysalesid) {
      state.encrysalesid = encrysalesid;
    },
    setIcsRecordsSalerInfo(state, icsRecordsSalerInfo) {
      state.icsRecordsSalerInfo = icsRecordsSalerInfo;
    },
    setBaseSalerInfo(state, baseSalerInfo) {
      state.baseSalerInfo = baseSalerInfo;
    },
    setSalesInfo(state, salesInfo) {
      state.salesInfo = salesInfo || { salesId: 0 };
    },
    setVrSalesInfo(state, vrSalesInfo) {
      state.vrSalesInfo = vrSalesInfo || { salesId: 0, channelId: '' };
    },
    setVrSaleSetting(state, setting) {
      state.saleSetting = setting;
    },
    setUserVisiteCount(state, count) {
      state.userVisitCount = count;
    },
    setOnlineSaler(state, saler) {
      state.onlineSaler = saler;
    },
    setSalesVRVisit(state, { acceptVisit, messageOpen }) {
      state.saleSetting.acceptVisit = acceptVisit;
      state.saleSetting.messageOpen = messageOpen;
    },
    setUserInfo(state, user) {
      state.userInfo = user;
    },
  },
  actions: {
    getBaseSalerInfo({ commit }, { saleId = 0, encryptedInfo = '' }) {
      return vrShowApi
        .getSalesById(saleId, encryptedInfo)
        .then(function (data) {
          commit('setBaseSalerInfo', data.result);
        })
        .catch(function (ex) {
          console.error('getBaseSalerInfo', ex);
        });
    },
    getSaleVrSetting({ commit }, { dealerId, encryptedInfo = '' }) {
      return vrShowApi
        .getSaleVrSetting(dealerId, encryptedInfo)
        .then(function (data) {
          commit('setVrSaleSetting', data.result);
        })
        .catch(function (ex) {
          console.error('getSaleVrSetting', ex);
        });
    },
    hasCountForUser({ commit }, { dealerId }) {
      return vrShowApi
        .hasCountForUser({
          dealerId: dealerId,
        })
        .then((res) => {
          if (res.returncode === 0 && res.result && res.result > 0) {
            commit('setUserVisiteCount', res.result);
          } else {
            commit('setUserVisiteCount', 0);
          }
        });
    },
    getOnlineSaler({ commit }, { dealerId, userId, ext }) {
      const timestamp = new Date().getTime();
      return vrShowApi
        .getServiceAdvisor({ dealerId, userId, timestamp, ext })
        .then((res) => {
          if (res.returncode === 0 && res.result.length > 0) {
            commit('setOnlineSaler', res.result[0]);
          } else {
            commit('setOnlineSaler', null);
          }
        })
        .catch(() => {
          commit('setOnlineSaler', null);
        });
    },
    setRemoteSalesVRVisit(
      { commit },
      { saleId, dealerId, acceptVisit, messageOpen },
    ) {
      return icsRecordsApi
        .setSalesVRVisitApi({ saleId, dealerId, acceptVisit, messageOpen })
        .then(() => {
          setTimeout(() => {
            commit('setSalesVRVisit', { acceptVisit: true, messageOpen: true });
          }, 1500);
        })
        .catch((err) => {
          console.error('setSalesVRVisit', err);
        });
    },
    getIcsRecordsSalerInfo({ commit }, { encryptedInfo = '', dealerId = 0 }) {
      return icsRecordsApi
        .getSaleInfo({ encryptedInfo, dealerId })
        .then(function (data) {
          commit('setIcsRecordsSalerInfo', data);
          window.sessionStorage.setItem(constName.TOKEN_KEY, data.token);
          return data;
        })
        .catch(function (ex) {
          console.error('setIcsRecordsSalerInfo', ex);
        });
    },
  },
  namespaced: true,
};
